import { Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  onClose: () => void
  disabled: boolean
}

const Footer = ({ onClose, disabled }: Props) => {
  return (
    <>
      <Button type="secondary" onClick={onClose}>
        {i18n.t('common.cancel')}
      </Button>
      <Button disabled={disabled} submit>
        {i18n.t('common.save')}
      </Button>
    </>
  )
}

export default Footer
